import React, {Component} from 'react'
import {NavLink as Link} from 'react-router-dom'
import {Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink} from 'reactstrap'

class Menu extends Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this)
        this.state = {
            isOpen: false,
        }
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        return (
            <div>
                <Navbar className="menu" dark expand="md">
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="menu-items" navbar>
                            <NavItem>
                                <NavLink tag={Link} exact activeClassName="selected" to="/">
                                    <i className="fas fa-home" /> Domov
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} activeClassName="selected" to="/kariera/">
                                    <i className="fas fa-briefcase" /> Kariera
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} activeClassName="selected" to="/kontakt/">
                                    <i className="fas fa-envelope" /> Kontakt
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        )
    }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js